import { cloneDeep } from 'lodash';
import { saveStates } from '@/constants/lifecycle';
import { openEntityDialog, entityVisibility } from '@/constants/states';
import { isPmnTransferEnabled } from '@/auth/featureToggles';
import findResult, { findWithCodes, removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { datasetSettingsCategories } from '../constants';

export const datasetSettingsFields = (
  allowInternal = false,
  allowPrivate = false,
  allowCounts = false,
  allowVisualisations = false,
  allowUpdateSubscriptions = false,
  datasetActions = [],
  workflowKey = null,
  visibility = entityVisibility.PRIVATE,
  allowClearTransfers = true,
  allowPseudonymisedTransfers = false,
  allowManualTransfers = false,
  catalogueTemplate = null,
  minCohortSize = 0,
) => ({
  allow_dataset_update_subscriptions: allowUpdateSubscriptions,
  allow_internal_cohorts: allowInternal,
  allow_private_cohorts: allowPrivate,
  allow_clear: allowClearTransfers,
  allow_pseudonymised: allowPseudonymisedTransfers,
  allow_manual: allowManualTransfers,
  dataset_actions: datasetActions,
  expose_cohort_counts: allowCounts,
  expose_cohort_visualisations: allowVisualisations,
  visibility,
  workflow_key: workflowKey,
  catalogue_definition_code: catalogueTemplate,
  minimum_cohort_size: minCohortSize,
});

export const confirmCatalogueChange = () => ({
  ...openEntityDialog,
  previousTitle: null,
  ...saveStates,
  template: { code: '', name: '' },
  title: null,
});

export const confirmDatasetWizardChange = () => ({
  datasourceChanged: false,
  ...openEntityDialog,
  previousTitle: null,
  ...saveStates,
  template: { code: '', name: '' },
  templateChanged: false,
  title: null,
});

export const editCohortSettings = () => ({
  ...openEntityDialog,
  minimum_cohort_size: 0,
  ...saveStates,
  title: null,
});

export const confirmWorkflowChange = () => ({
  ...openEntityDialog,
  ...saveStates,
  title: null,
  workflow: {
    code: null,
    workflow: {
      key: null,
      name: '',
    },
  },
});

export const settingsPanels = (openPanels = [0]) => ({
  panels: {
    single: openPanels,
    left: openPanels,
    right: openPanels,
  },
});

export const cloneDatasetSettings = ({ settings }) => {
  const copy = cloneDeep(settings);
  copy.visibility = entityVisibility.PRIVATE;

  return copy;
};

const initialState = {
  confirmCatalogue: confirmCatalogueChange(),
  confirmWizard: confirmDatasetWizardChange(),
  confirmWorkflow: confirmWorkflowChange(),
  allowPmnTransfer: isPmnTransferEnabled(),
  cohortSettings: editCohortSettings(),
  settings: {
    open: {
      results: [],
    },
  },
};

export const findDatasetSettings = ({ settings }, { category, code }) => (
  findResult(settings, category, code)
);

export const findAllDatasetSettings = ({ settings }, { items }) => {
  const codes = items.map(({ code }) => code);
  return findWithCodes(settings, datasetSettingsCategories, codes);
};

export const closeDatasetSettingsState = withDraft((draft, { category, code }) => {
  const item = findDatasetSettings(draft, { category, code });

  if (item) {
    draft.settings[category].results = removeItemByCode(draft.settings[category].results, item);
  }
});

export default initialState;
